function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil12{fill:#13b4b6}.fil8{fill:#2e9586}.fil11{fill:#356695}.fil6{fill:#393f95}.fil9{fill:#692d8b}.fil7{fill:#952387}.fil15{fill:#b8d32b}.fil10{fill:#bf0072}.fil5{fill:#ce0948}.fil0{fill:#d4de37}.fil4{fill:#e23a11}.fil13{fill:#e24e0e}.fil14{fill:#e50c12}.fil2{fill:#e77800}.fil3{fill:#ea8a00}.fil1{fill:#f6b200}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m439 1270 2 36 7 23 42 12-28-71h-23zM542 1351c3 1 6 1 9 2l3-16h-12v14zM629 1292l-6 67c9 1 19 1 28 1 38 0 76-3 112-9l2-62-69-55-67 58zM850 1285l4 44c31-10 61-21 89-35l1-37-35-23-59 51z",
  className: "fil0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m187 1092-6 79c10 10 21 20 33 29v-61l-11-51-16 4zM365 1055l-1 14 53 165 19 21 11-21-73-181zM589 1049l-9 12-13 27c-12 39-20 87-24 146l47 23 106-23-23-114-84-71zM802 1049l-83 63-23 122 106 38 107-38-21-126zM1061 1128c-20 23-48 44-85 60 10-13 6-34-7-59l-31 12-29 93 68 30 68-30c18-13 36-27 53-42l-5-59-32-5z",
  className: "fil1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M585 1041c-2 3-3 6-4 8l3 2 5-2-1-5-3-3zM749 957l-1-2c-43-9-86-3-121 28l-21 31-17 35 105 29 108-29-21-58-32-34zM808 1005l-6 44 71 41 34-41c-21-21-46-40-72-57l-27 13zM1122 865l-27 47c6 18 10 38 11 57 2 26 1 53-5 80l20 45 100-45c1-2 3-4 4-6l-30-113-73-65z",
  className: "fil2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m191 1049-4 43 9 40 18 7 2-90-9-22zM372 1049l-9-9-5 9 6 20 12 3-2-19z",
  className: "fil3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m27 814-17 51 11 6 17-6 6-22-3-20zM1015 680l-36 16 2 44c40 39 73 81 95 125l18 8 28-8-26-121-81-64zM1229 680l-77 59-30 126 108 24 74-24c4-13 7-25 9-38l-11-106-73-41z",
  className: "fil4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m71 680 4 12 12-12 23-91 1-15-6 6z",
  className: "fil5"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m648 578 57 82-4 20 9 9 14-9 11-17-85-88z",
  className: "fil6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m850 588 1 7c5 12 9 23 11 31-2-14-5-25-8-36l-4-2zM909 495l-33 26-2 35c27 41 53 90 68 124l37 30 36-30-41-114-65-71zM1122 495l-74 55-33 130 107 23 107-23-29-108zM1257 557l-28 123 73 41 27-41c0-50-6-99-16-146l-56 23z",
  className: "fil5"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m589 311-17 13-1 18c16 7 33 14 49 22l-12-39-19-14zM802 311l-58 73-3 34c22 24 42 51 59 77l10 7 9-7-2-4c2 1 4 3 6 4l34 15 52-15-39-118-68-66zM1015 311l-84 61-22 123 110 45 103-45-40-116zM1162 379l-40 116 112 38 69-38c-18-63-45-122-79-176l-62 60z",
  className: "fil7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M128 250c-16 19-31 40-45 61l25 15 51-15c1-1 2-1 3-1l-5-48-29-12zM269 126l-64 78-41 105c60-19 129-25 200-18l-17-86-78-79zM483 126l-73 68-24 99c30 4 60 10 90 18l58 7 55-7-25-117-81-68zM696 126l-67 71-40 114 124 34 89-34-31-110zM909 126l-76 95-31 90 107 19 106-19-30-99zM1097 170l-50 50-32 91 114 31 90-31c-34-52-76-100-122-141z",
  className: "fil6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m275 117-6 9 111 34 103-34 8-57-59-30c-56 19-109 46-157 78zM625 4c-26 1-51 3-76 7l-43 36-23 79 106 27 107-27-31-88-40-34zM856 35c-31-10-62-17-95-23l-40 26-25 88 104 30 109-30-10-45-43-46zM912 74l-3 52 98 30 33-30c-31-22-63-41-98-57l-30 5z",
  className: "fil8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M45 377c32-30 71-52 114-66H83c-14 21-27 43-38 66z",
  className: "fil9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m105 580 5 8v1l25-94h-2z",
  className: "fil10"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m128 250 34 60 2-1 52-90 53-93h-8c-50 35-95 77-133 124z",
  className: "fil11"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m135 495 6-23-8 23z",
  className: "fil7"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M221 680v-10l-1 10z",
  className: "fil5"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M261 126h8l-2-4c-2 2-4 3-6 4z",
  className: "fil8"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m269 126 6-9c-3 2-5 3-8 5l2 4z",
  className: "fil12"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m269 126 54 93 41 72c8 0 15 1 22 2l43-74 54-93H269z",
  className: "fil11"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M476 311c31 8 63 19 95 31l18-31H476z",
  className: "fil9"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m648 578 2-3-18-19z",
  className: "fil6"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m483 126 53-92 13-23c-40 6-79 15-117 28l51 87z",
  className: "fil12"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m483 126 53 93 53 92 53-92 54-93H589z",
  className: "fil11"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m589 311 31 53c4 2 7 4 11 6 7 3-14-33-8-31 45 14 84 43 118 79l8-15 53-92H589z",
  className: "fil9"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M802 495h-2c22 36 40 72 51 100l3-5c-8-30-19-52-35-95h-17zM874 556l35-61h-86c16 14 34 36 51 61z",
  className: "fil10"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m625 4 17 30 54 92 53-92 12-22c-36-6-73-9-110-9-9 0-18 0-26 1z",
  className: "fil12"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m696 126 53 93 53 92 54-92 53-93H802z",
  className: "fil11"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m802 311 54 92 53 92 53-92 53-92H909z",
  className: "fil9"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m909 495 53 93 53 92 54-92 53-93h-107z",
  className: "fil10"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m909 126 33-57c-28-13-56-25-86-34l53 91z",
  className: "fil12"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M1015 126H909l53 93 53 92 54-92 28-49c-18-15-37-30-57-44h-25z",
  className: "fil11"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M1122 311h-107l54 92 53 92 53-92 49-84c-2-3-3-6-5-8h-97z",
  className: "fil9"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M1229 495h-107l53 93 54 92 53-92 31-54c-3-13-6-26-10-39h-74z",
  className: "fil10"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M3 884c5 16 10 30 16 45l5-8 14-56H10l-7 19z",
  className: "fil13"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "m27 814 17 29 43-163H71z",
  className: "fil14"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m21 933 3-12-5 8z",
  className: "fil2"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "m206 865-11 128 17-12 5-26 1-90-5-15z",
  className: "fil13"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "m417 1234 24 72 21-36-15-36z",
  className: "fil15"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "m213 768-7 97h12l2-87-4-6z",
  className: "fil4"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "m213 768 3 4 4 6 1-98h-1z",
  className: "fil14"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "m195 993-4 56h25l1-94-1 2zM335 978l23 71h14l-9-22z",
  className: "fil2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "m335 978 28 49-61-151z",
  className: "fil13"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "m567 1088 22-39h-8c-5 12-10 25-14 39z",
  className: "fil3"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M543 1234c-2 31-2 65-1 103l9 16c24 3 48 5 72 6l19-33 54-92H543z",
  className: "fil15"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "m585 1041 4 8 38-66c-16 14-30 33-42 58z",
  className: "fil13"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "m589 1049 53 92 54 93 53-93 53-92H696z",
  className: "fil3"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "m696 1234 53 92 14 25c31-6 61-13 91-22l2-3 53-92H696z",
  className: "fil15"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "m691 734 33-54h-23z",
  className: "fil6"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "m749 957 53 92 33-57c-28-17-58-30-87-37l1 2z",
  className: "fil13"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "m802 1049 54 92 53 93 53-93 7-12c-13-25-34-53-62-80H802z",
  className: "fil3"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "m909 1234 34 60c36-17 70-37 102-60H909z",
  className: "fil15"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M956 716c8 8 17 16 25 24l34-60h-73c7 17 12 30 14 36z",
  className: "fil14"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "m1095 912 27-47h-46c8 15 14 31 19 47z",
  className: "fil13"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M1101 1049c-7 28-20 55-40 79l8 13 29 51c47-42 89-90 123-143h-120z",
  className: "fil3"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "m1015 680 54 92 53 93 53-93 54-92h-107z",
  className: "fil14"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "m1122 865 53 92 50 86c34-55 61-115 79-178h-182z",
  className: "fil13"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "m1229 680 53 92 31 55c11-47 16-95 16-145v-2h-100z",
  className: "fil14"
});

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 192.639,
    height: 51.519,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5097 1363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2243107204384"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, /*#__PURE__*/React.createElement("path", {
    d: "M3730 525h-180v-63h180z",
    style: {
      fill: "#bf0072",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827 739c-66 0-117-21-155-61-37-41-55-94-55-160v-18c0-63 18-115 55-157 36-41 81-62 134-62 58 0 103 18 132 55 30 37 44 85 44 146v43h-282v2c-1 44 10 80 31 107 21 28 53 42 96 42 26 0 48-3 63-8 16-6 35-15 56-26l20 57c-15 10-32 20-53 28-22 8-50 12-86 12zm-21-395c-29 0-52 11-70 32-18 22-30 50-34 84l1 1h199v-6c0-32-8-58-24-80-15-20-40-31-72-31zm538 386c-3-13-5-25-7-35-1-10-2-21-2-31-15 21-35 39-59 53-24 15-50 22-78 22-45 0-80-12-104-36-25-23-37-56-37-97 0-42 17-75 52-99 34-23 80-35 138-35h88v-44c0-26-8-46-24-61s-38-23-67-23c-26 0-47 7-63 20s-24 28-24 47h-76l-1-2c-2-32 13-61 45-88s73-40 124-40c50 0 90 13 120 38 31 25 46 62 46 110v212c0 16 1 31 2 46 2 15 5 29 9 43h-82zm-134-59c29 0 56-7 79-22s39-32 46-51v-72h-90c-33 0-59 8-78 24-19 17-29 36-29 58 0 19 6 35 18 46 12 12 30 17 54 17zm307-153c0-71 15-128 46-172 30-43 72-65 127-65 28 0 52 6 73 17 22 11 39 27 54 49l10-58h64v444c0 56-17 100-50 130s-80 45-142 45c-21 0-44-3-69-9-24-5-46-13-65-23l13-63c15 8 34 15 56 20 21 5 43 8 64 8 39 0 68-9 86-27 17-18 26-45 26-81v-51c-14 19-31 33-51 42-21 10-44 15-70 15-54 0-96-20-126-59-31-39-46-90-46-154v-8zm81 8c0 45 9 80 27 107s46 40 84 40c24 0 45-5 61-16s30-27 40-47V407c-10-18-24-33-40-44-17-11-37-17-60-17-38 0-67 16-85 48s-27 73-27 124v8zm495 204h-81V94h81v636zm314 9c-65 0-117-21-154-61-37-41-55-94-55-160v-18c0-63 18-115 54-157 37-41 82-62 134-62 59 0 103 18 133 55 29 37 44 85 44 146v43h-282l-1 2c0 44 10 80 31 107 21 28 53 42 96 42 27 0 48-3 64-8 16-6 34-15 56-26l20 57c-15 10-33 20-54 28s-49 12-86 12zm-21-395c-28 0-51 11-69 32-19 22-30 50-34 84l1 1h199v-6c0-32-8-58-24-80-15-20-40-31-73-31z",
    style: {
      fill: "#393f96",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 1222h-30V988h30v234zm115 3c-24 0-43-7-56-22-14-15-21-35-21-59v-6c0-24 7-43 20-58 14-15 30-23 50-23 21 0 38 7 48 20 11 14 17 32 17 54v16h-104c0 17 3 30 11 40s20 15 35 15c10 0 18-1 24-3s12-5 20-9l8 21c-6 4-12 7-20 10s-18 4-32 4zm-7-145c-11 0-19 4-26 12s-11 18-12 31h73v-2c0-12-3-22-9-29-5-8-14-12-26-12zm198 142c-1-5-2-9-3-13 0-4-1-7-1-11-5 8-12 14-21 19-9 6-19 8-29 8-17 0-30-4-38-13-9-8-14-20-14-35 0-16 7-28 19-37 13-9 30-13 51-13h32v-16c0-9-3-17-8-23-6-5-14-8-25-8-10 0-17 3-23 7-6 5-9 11-9 18h-28v-1c-1-12 4-23 16-32 12-10 27-15 46-15 18 0 33 5 44 14s17 23 17 40v78c0 6 0 12 1 17 0 6 1 11 3 16h-30zm-50-21c11 0 21-3 29-9 9-5 15-12 17-19v-26h-33c-12 0-21 3-28 9-8 6-11 13-11 21 0 7 2 13 7 17 4 4 11 7 19 7zm195-115-15-1c-7 0-14 2-19 6-6 3-10 9-13 15v116h-29v-162h26l2 25c5-9 10-16 17-21s15-7 24-7h7c2 1 3 1 4 2l-4 27zm58-26 2 24c5-9 12-15 20-20s17-7 28-7c17 0 31 5 40 15 10 11 15 26 15 48v102h-30v-102c0-14-3-24-8-30-6-6-14-9-26-9-9 0-17 2-23 5-7 4-12 9-15 16v120h-30v-162h27zm180 162h-30v-162h30v162zm0-204h-30v-30h30v30zm71 42 3 24c5-9 12-15 20-20s17-7 28-7c17 0 31 5 40 15 10 11 15 26 15 48v102h-30v-102c0-14-3-24-8-30-6-6-15-9-26-9-9 0-17 2-23 5-7 4-12 9-15 16v120h-30v-162h26zm143 84c0-26 6-47 17-63s27-24 47-24c10 0 19 2 27 6s14 10 20 18l3-21h24v163c0 21-6 37-18 48-13 11-30 17-53 17-8 0-16-1-25-4-9-2-17-5-24-8l5-23c5 3 12 5 20 7s16 3 24 3c14 0 25-4 31-10 7-7 10-17 10-30v-18c-5 6-11 12-19 15-7 4-16 5-25 5-20 0-36-7-47-21-11-15-17-33-17-57v-3zm30 3c0 17 3 30 10 39 7 10 17 15 31 15 9 0 16-2 22-6s11-10 15-17v-75c-4-6-9-12-15-16s-13-6-22-6c-14 0-24 6-31 17-7 12-10 27-10 46v3zm326 75c-1-5-2-9-2-13-1-4-1-7-1-11-6 8-13 14-22 19-8 6-18 8-28 8-17 0-30-4-39-13-9-8-13-20-13-35 0-16 6-28 19-37 12-9 29-13 51-13h32v-16c0-9-3-17-9-23-6-5-14-8-24-8s-18 3-24 7c-6 5-9 11-9 18h-28v-1c-1-12 5-23 17-32 11-10 27-15 45-15 19 0 33 5 45 14 11 9 16 23 16 40v78c0 6 1 12 1 17 1 6 2 11 4 16h-31zm-49-21c11 0 21-3 29-9 9-5 14-12 17-19v-26h-33c-12 0-22 3-29 9s-11 13-11 21c0 7 3 13 7 17 5 4 11 7 20 7zm145-141 2 24c5-9 12-15 20-20s18-7 28-7c17 0 31 5 41 15 9 11 14 26 14 48v102h-30v-102c0-14-2-24-8-30s-14-9-26-9c-9 0-17 2-23 5-6 4-12 9-15 16v120h-30v-162h27zm141 84c0-26 6-47 17-63s27-24 47-24c9 0 18 2 25 5 7 4 14 9 19 15v-89h29v234h-22l-5-20c-5 7-12 13-19 17-8 4-17 6-28 6-19 0-35-7-46-21-11-15-17-33-17-57v-3zm30 3c0 17 3 30 10 40 6 9 17 14 31 14 9 0 16-2 22-6s11-9 15-16v-76c-4-7-9-12-15-16s-13-6-22-6c-14 0-24 6-31 17-7 12-10 27-10 46v3zm236 75v-140h-26v-22h26v-21c0-17 4-30 13-40 9-9 22-14 38-14 4 0 7 0 10 1 4 0 8 1 12 2l-4 23c-1-1-4-1-6-1-3-1-5-1-8-1-9 0-15 3-19 8s-7 13-7 22v21h30v22h-30v140h-29zm188-24c-5 9-11 15-20 20-8 5-17 7-27 7-18 0-32-5-42-17-9-11-14-29-14-52v-96h29v96c0 17 3 29 8 36 5 6 13 9 24 9 10 0 19-2 26-6 6-4 12-11 15-18v-117h30v162h-27l-2-24zm98-138 2 24c6-9 12-15 21-20 8-5 17-7 27-7 18 0 31 5 41 15 10 11 14 26 14 48v102h-29v-102c0-14-3-24-9-30-5-6-14-9-25-9-10 0-17 2-24 5-6 4-11 9-15 16v120h-29v-162h26zm262-39v39h31v22h-31v98c0 8 2 13 5 16s7 5 12 5c2 0 4 0 6-1 2 0 4 0 6-1l4 20c-3 2-6 3-10 5-5 1-9 1-13 1-12 0-21-3-29-11-7-7-10-18-10-34v-98h-26v-22h26v-39h29zm54 119c0-24 6-44 19-60 13-15 31-23 53-23s40 8 53 23c13 16 20 35 20 60v3c0 24-7 44-20 59-13 16-30 23-53 23-22 0-40-7-53-23-13-15-19-35-19-59v-3zm29 3c0 17 4 31 11 42 7 12 18 17 32 17s25-5 32-17c8-11 11-25 11-42v-3c0-17-3-32-11-43-7-11-18-17-32-17s-25 6-32 17-11 26-11 43v3zm147 1c0-26 5-47 16-63 12-16 27-24 47-24 10 0 20 2 27 6 8 4 15 10 20 18l4-21h23v163c0 21-6 37-18 48s-30 17-52 17c-8 0-17-1-26-4-9-2-17-5-24-8l5-23c6 3 13 5 21 7s16 3 23 3c15 0 25-4 32-10 6-7 10-17 10-30v-18c-6 6-12 12-19 15-8 4-16 5-26 5-20 0-35-7-47-21-11-15-16-33-16-57v-3zm29 3c0 17 4 30 10 39 7 10 17 15 31 15 9 0 17-2 23-6s11-10 15-17v-75c-4-6-9-12-15-16s-14-6-22-6c-14 0-25 6-32 17-6 12-10 27-10 46v3zm221 78c-24 0-43-7-57-22s-20-35-20-59v-6c0-24 6-43 20-58 13-15 30-23 49-23 22 0 38 7 49 20 11 14 16 32 16 54v16h-104c0 17 4 30 12 40 7 10 19 15 35 15 10 0 17-1 23-3s13-5 21-9l7 21c-5 4-12 7-20 10-7 3-18 4-31 4zm-8-145c-10 0-19 4-26 12-6 8-10 18-12 31h74v-2c0-12-3-22-9-29-6-8-15-12-27-12zm136-59v39h31v22h-31v98c0 8 1 13 5 16 3 3 7 5 12 5 2 0 4 0 6-1 2 0 4 0 5-1l4 20c-2 2-5 3-10 5-4 1-8 1-12 1-12 0-22-3-29-11-7-7-11-18-11-34v-98h-25v-22h25v-39h30zm90 61c5-8 12-14 20-19 8-4 17-6 27-6 18 0 31 5 41 16 9 10 14 26 14 48v101h-29v-102c0-13-3-23-9-29-6-7-14-10-26-10-8 0-16 2-23 5-6 4-11 8-15 15v121h-30V988h30v94zm215 143c-24 0-43-7-57-22-13-15-20-35-20-59v-6c0-24 7-43 20-58s30-23 49-23c22 0 38 7 49 20 11 14 16 32 16 54v16h-104c0 17 4 30 12 40 7 10 19 15 35 15 10 0 18-1 23-3 6-2 13-5 21-9l7 21c-5 4-12 7-19 10-8 3-19 4-32 4zm-8-145c-10 0-19 4-25 12-7 8-11 18-13 31h74v-2c0-12-3-22-9-29-6-8-15-12-27-12zm175 6-15-1c-8 0-14 2-20 6-5 3-9 9-12 15v116h-30v-162h27l2 25c4-9 10-16 17-21s15-7 24-7h6c2 1 4 1 5 2l-4 27z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3920 737c-65 0-117-20-154-61-37-40-55-94-55-159v-18c0-63 18-116 54-157 37-42 82-63 134-63 59 0 103 19 133 56 29 36 44 85 44 146v42h-282l-1 2c0 44 10 80 31 108s53 41 96 41c27 0 48-2 64-8 16-5 34-14 56-25l20 56c-15 11-33 20-54 28s-49 12-86 12zm-21-394c-28 0-51 10-69 32-19 22-30 49-34 83l1 2h199v-7c0-32-8-58-24-79-15-21-40-31-73-31zm249 173c0-71 15-128 45-171 31-44 73-66 128-66 26 0 48 5 68 15 21 9 37 23 52 41V93h80v636h-62l-12-56c-14 21-32 37-53 48s-46 16-74 16c-54 0-96-19-126-58-31-39-46-91-46-154v-9zm80 9c0 44 9 80 28 107 18 27 46 40 84 40 24 0 44-5 61-16 16-11 29-26 40-46V404c-11-18-24-32-41-43-16-11-36-16-59-16-38 0-67 16-85 47-19 32-28 73-28 124v9zm693 138c-14 24-32 42-54 55s-47 19-75 19c-48 0-86-15-113-46-26-30-40-78-40-143V288h80v261c0 47 7 79 21 96 14 18 36 27 65 27s52-6 71-17c18-12 32-29 42-50V288h80v441h-72l-5-66z",
    style: {
      fill: "#58595a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5073 707h20.356v151.218H5073z",
    style: {
      fill: "#fefefe",
      stroke: "#fefefe",
      strokeWidth: 20
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.f4dc59b92814ca4fad46d196b8d0a864.svg";
export { ForwardRef as ReactComponent };